
export const listMutations = <const>{
	ACOOUNTING_ZAKAZNIK_FILTER_SELECT_MAPPER: 'ACOOUNTING_ZAKAZNIK_FILTER_SELECT_MAPPER',
};
